/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/viewtime';

/**
 * displayViewTime
 * url - /checkout/{apiversion}/cart/{cartId}/viewtime?cartItemId={cartItemId}&startDate={startDate}d&zipCode={zipcode}&state={state}&country={country}
 *
 * @param {Object} args
 * @param {String} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.cartItemId
 * @param {String} args.startDate
 * @param {String} args.zipCode
 * @param {String} args.state
 * @param {String} args.country

 */
const displayViewTime = ({
    env,
    jwtToken,
    cartId,
    cartItemId,
    startDate,
    zipCode,
    state,
    country,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;

    const payload = {
        cartItemId,
        startDate,
        zipCode,
        state,
        country,
    };
    return restClient.getRequest(envObj, resourcePage, jwtToken, payload).then((response) => response);
};
export default displayViewTime;
